/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ChartOfAccountsTable_glAccountEdges$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PaginatedGLAccountsContainer_glAccounts$ref: FragmentReference;
declare export opaque type PaginatedGLAccountsContainer_glAccounts$fragmentType: PaginatedGLAccountsContainer_glAccounts$ref;
export type PaginatedGLAccountsContainer_glAccounts = {|
  +glAccounts: {|
    +edges: ?$ReadOnlyArray<?{|
      +cursor: string,
      +$fragmentRefs: ChartOfAccountsTable_glAccountEdges$ref,
    |}>
  |},
  +$refType: PaginatedGLAccountsContainer_glAccounts$ref,
|};
export type PaginatedGLAccountsContainer_glAccounts$data = PaginatedGLAccountsContainer_glAccounts;
export type PaginatedGLAccountsContainer_glAccounts$key = {
  +$data?: PaginatedGLAccountsContainer_glAccounts$data,
  +$fragmentRefs: PaginatedGLAccountsContainer_glAccounts$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PaginatedGLAccountsContainer_glAccounts",
  "type": "Query",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "glAccounts"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": 30
    },
    {
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "search",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "sortBy",
      "type": "GLAccountSort",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "accountTypes",
      "type": "[GLAccountType!]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "isActive",
      "type": "Boolean",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "glAccounts",
      "name": "__PaginatedGLAccountsContainer_glAccounts_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "GLAccountConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "GLAccountEdge",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "GLAccount",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "ChartOfAccountsTable_glAccountEdges",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '465fabbf15cb5d1954251354e4b0eff0';
module.exports = node;
